module.exports = __webpack_public_path__ + "img/0f020f1b6e5554e8550f19d385989d53.png";